import React from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/AuthFetch";
import { Typeahead } from "react-bootstrap-typeahead";
import HalfYearly from "../../components/report/HalfYearly";
import Annual from "../../components/report/Annual";

function Result({ Type }) {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const [loader, setLoader] = useState(false);

  const [standard, setStandard] = useState("");
  const [standardList, setStandardList] = useState([]);

  const [finYear, setFinYear] = useState("");
  const [finYearList, setFinYearList] = useState([]);

  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);

  const [student, setStudent] = useState(null);
  const [studentList, setStudentList] = useState([]);

  const [marksData, setMarksData] = useState([]);
  const [maxMarksData, setMaxMarksData] = useState({});
  const [total, setTotal] = useState(0);
  const [annualPercent, setAnnualPercent] = useState({});

  const hasStandard = !!standard;
  const hasDiv = !!div;
  const hasFinYear = !!finYear;
  const hasStudent = !!student;

  const standardLabel =
    standardList.find((s) => s.id === Number(standard))?.standard || "";

  const divisionLabel =
    divList.find((d) => d.id === Number(div))?.division || "";

  const finYearLabel =
    finYearList.find((f) => f.id === Number(finYear))?.fyName || "";

  useEffect(() => {
    // reset form selections
    setStandard("");

    setDiv("");
    setDivList([]);

    setFinYear("");
    setFinYearList([]);

    setStudent(null);
    setStudentList([]);

    // reset result data
    setMarksData([]);
    setMaxMarksData({});
    setTotal(0);
    setAnnualPercent({});
  }, [Type]);

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`,
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setLoader(true);
    setDiv("");
    setDivList([]);
    setFinYearList([]);
    setFinYear("");
    setStudentList([]);
    setStudent(null);
    if (standard === "") {
      setLoader(false);
      return;
    }
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`,
      );
      const result = await response.json();
      setDivList(result.division);
    } catch (error) {
      console.error("Error fetching division:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchFinYear = async (div) => {
    setLoader(true);
    setFinYearList([]);
    setFinYear("");
    setStudent(null);
    setStudentList([]);
    if (div === "") {
      setLoader(false);
      return;
    }
    try {
      const response = await authFetch(`${API_BASE_URL}/api/finYear`);
      const result = await response.json();
      setFinYearList(result.finYear);
    } catch (error) {
      console.error("Error fetching financial year:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchStudents = async (finYear) => {
    setLoader(true);
    setStudentList([]);
    setStudent(null);
    if (finYear === "" || finYear === null) {
      setLoader(false);
      return;
    }
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/student?standard=${standard}&div=${div}&finYear=${finYear}`,
      );
      const result = await response.json();
      setStudentList(result.student);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchMarks = async (student) => {
    setLoader(true);
    if (student === "" || student === null) {
      setLoader(false);
      return;
    }
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/${Type}?student=${student}&finYear=${finYear}`,
      );
      const result = await response.json();
      setMarksData(result.result);
      setMaxMarksData(result.maxMarks);

      if (Type === "annual") {
        setAnnualPercent(result.annualPercent);

        const totalAnnual = result.result.reduce((sum, x) => {
          const val = Number(x.total);
          return sum + (isNaN(val) ? 0 : val);
        }, 0);

        setTotal(totalAnnual);
      } else {
        const totalHalfYearly = result.result.reduce((sum, x) => {
          const val = Number(x.halfYearly);
          return sum + (isNaN(val) ? 0 : val);
        }, 0);

        setTotal(totalHalfYearly);
      }
    } catch (error) {
      console.error("Error fetching marks:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">
              {Type.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
              Report
            </h5>
            <Form>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="class"
                      required
                      value={standard}
                      disabled={!standardList.length}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Class
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {hasStandard && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>
                          Section <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          value={div}
                          disabled={!divList.length}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDiv(value);
                            fetchFinYear(value);
                          }}
                          required
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {hasDiv && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formName">
                            <Form.Label>
                              Financial Year
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="finYear"
                              value={finYear}
                              disabled={!finYearList.length}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFinYear(value);
                                fetchStudents(value);
                              }}
                              required
                            >
                              <option value="" disabled>
                                Select Financial Year
                              </option>
                              {finYearList?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.fyName}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        {hasFinYear && (
                          <>
                            <Col md={4}>
                              <Form.Group
                                className="mb-3"
                                controlId="formStudent"
                              >
                                <Form.Label>
                                  Student <span className="text-danger">*</span>
                                </Form.Label>

                                <Typeahead
                                  id="student-typeahead"
                                  labelKey="name"
                                  options={studentList}
                                  disabled={!studentList.length}
                                  placeholder="Search Student"
                                  clearButton
                                  selected={student ? [student] : []}
                                  onChange={(selected) => {
                                    if (selected.length > 0) {
                                      setStudent(selected[0]);
                                      fetchMarks(selected[0].admission);
                                    } else {
                                      setStudent(null);
                                    }
                                  }}
                                />
                              </Form.Group>
                            </Col>

                            {hasStudent &&
                              (Type === "half-yearly" ? (
                                <HalfYearly
                                  {...{
                                    student,
                                    standardLabel,
                                    divisionLabel,
                                    marksData,
                                    maxMarksData,
                                    finYearLabel,
                                    total,
                                    setLoader,
                                    finYear,
                                  }}
                                />
                              ) : (
                                <Annual
                                  {...{
                                    student,
                                    standardLabel,
                                    divisionLabel,
                                    marksData,
                                    maxMarksData,
                                    annualPercent,
                                    finYearLabel,
                                    total,
                                    setLoader,
                                    finYear,
                                  }}
                                />
                              ))}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Result;
